
// We created this new to dont confuce with the other
// Virginia should be Inland and North Carolina should be Coastal 
import inlandLoadProfileVirginia from './inlandLoadProfileVirginia.json';
import coastalLoadProfileNC from "./coastalLoadProfileNC.json";


import {
  COASTAL,
  INLAND,
} from '../../constants/chargingClimateZones';

//OBS: We gonna change all to the same date duo client request to not separete bu climate zone
//TODO: Improve the logic and clean the code. Made like this duo the tiny deadline to code and align

const loadProfiles = {
  COASTAL: {
    rateGroup: 'TIERED',
    climateZone: COASTAL,
    nemStatus: 'NON-NEM',
    year: 2021,
    data: coastalLoadProfileNC,
  },
  INLAND: {
    rateGroup: 'TIERED',
    climateZone: INLAND,
    nemStatus: 'NON-NEM',
    year: 2021,
    data: inlandLoadProfileVirginia,
  },
};

const getLoadProfileData = ({ rateGroup, climateZone, hasSolar = false }) => {
  return loadProfiles[climateZone];
};

export default getLoadProfileData;
